/* eslint-disable no-param-reassign */
/* eslint-disable no-new */
/* eslint-disable no-restricted-syntax */
import Isotope from 'isotope-layout';
import ScrollReveal from 'scrollreveal';
import ImagesLoaded from 'imagesloaded';
import enquire from 'enquire.js';
import { breakpoints } from '../utils';

const grid = document.querySelector('.projects');

const makePortrait = (image) => {
    image.src = image.dataset.portraitSrc;
    image.srcset = image.dataset.portraitSrcset;
};

const makeLandscape = (image) => {
    image.src = image.dataset.landscapeSrc;
    image.srcset = image.dataset.landscapeSrcset;
};

const isotope = () => {
    // Isotope for project list
    new Isotope(grid, {
        // options
        itemSelector: '.projects__item',
        masonry: {
            columnWidth: '.grid-sizer',
        },
    });
};

if (grid) {
    const images = grid.querySelectorAll('.card__image img');
    const shouldBePortraitIndex = [1, 4]; // zero-indexed and % 7 (2nd & 5th)
    enquire.register(breakpoints['lap-and-up'], {

        match() {
            images.forEach((image, index) => {
                if (shouldBePortraitIndex.includes(index % 7)) {
                    makePortrait(image);
                }
            });

            ImagesLoaded(grid, () => {
                isotope();

                window.src = ScrollReveal()
                    .reveal('.projects__item', { mobile: false });
            });
        },

        unmatch() {
            for (const image of images) {
                makeLandscape(image);
            }
        },
    });
}



// WEBPACK FOOTER //
// ./source/scripts/components/projects.js